/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { PaymentStatus } from './PaymentStatus';
import {
    PaymentStatusFromJSON,
    PaymentStatusFromJSONTyped,
    PaymentStatusToJSON,
    PaymentStatusToJSONTyped,
} from './PaymentStatus';

/**
 * 
 * @export
 * @interface ScrollPaymentsQuery
 */
export interface ScrollPaymentsQuery {
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ScrollPaymentsQuery
     */
    userId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ScrollPaymentsQuery
     */
    studentId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ScrollPaymentsQuery
     */
    locationId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {any}
     * @memberof ScrollPaymentsQuery
     */
    transactionDateFrom: any | null;
    /**
     * 
     * @type {any}
     * @memberof ScrollPaymentsQuery
     */
    transactionDateTo: any | null;
    /**
     * 
     * @type {PaymentStatus}
     * @memberof ScrollPaymentsQuery
     */
    paymentStatus: PaymentStatus | null;
}



/**
 * Check if a given object implements the ScrollPaymentsQuery interface.
 */
export function instanceOfScrollPaymentsQuery(value: object): value is ScrollPaymentsQuery {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('transactionDateFrom' in value) || value['transactionDateFrom'] === undefined) return false;
    if (!('transactionDateTo' in value) || value['transactionDateTo'] === undefined) return false;
    if (!('paymentStatus' in value) || value['paymentStatus'] === undefined) return false;
    return true;
}

export function ScrollPaymentsQueryFromJSON(json: any): ScrollPaymentsQuery {
    return ScrollPaymentsQueryFromJSONTyped(json, false);
}

export function ScrollPaymentsQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScrollPaymentsQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ActorActivityRecordActorUserIdFromJSON(json['userId']),
        'studentId': ActorActivityRecordActorUserIdFromJSON(json['studentId']),
        'locationId': ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'transactionDateFrom': json['transactionDateFrom'],
        'transactionDateTo': json['transactionDateTo'],
        'paymentStatus': PaymentStatusFromJSON(json['paymentStatus']),
    };
}

export function ScrollPaymentsQueryToJSON(json: any): ScrollPaymentsQuery {
    return ScrollPaymentsQueryToJSONTyped(json, false);
}

export function ScrollPaymentsQueryToJSONTyped(value?: ScrollPaymentsQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ActorActivityRecordActorUserIdToJSON(value['userId']),
        'studentId': ActorActivityRecordActorUserIdToJSON(value['studentId']),
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'transactionDateFrom': value['transactionDateFrom'],
        'transactionDateTo': value['transactionDateTo'],
        'paymentStatus': PaymentStatusToJSON(value['paymentStatus']),
    };
}

